export enum PayFundStatus {
  OPEN,
  CLOSED,
}
